export default "/images/recruit-personal-dashboard.png?51f221785ebbddfc3072669643097a42";